/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Notes_HelpInputs */

const en_recipe_notes_help = /** @type {(inputs: Recipe_Notes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only your household sees these, never share links.`)
};

const de_recipe_notes_help = /** @type {(inputs: Recipe_Notes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur dein Haushalt sieht sie, nie über geteilte Links.`)
};

/**
* | output |
* | --- |
* | "Only your household sees these, never share links." |
*
* @param {Recipe_Notes_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_notes_help = /** @type {((inputs?: Recipe_Notes_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Notes_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_notes_help(inputs)
	return en_recipe_notes_help(inputs)
});